export const styles = {
  container: { paddingBottom: '20px' },
  bannerStyles: { margin: '-24px -48px 24px' },
};
